import { z } from "zod";

export const updateProfileFormSchema = z.object({
  first_name: z.string().min(1, "First name is required"),
  last_name: z.string().min(1, "Last name is required"),
  email: z.string().email("Invalid email address"),
  phone_number: z.string().min(1, "Phone number is required"),
  state: z.string().min(1, "State is required"),
  city: z.string().optional(),
  date_of_birth: z
    .string()
    .min(1, "Date of birth is required")
    .refine((dob) => {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age >= 18;
    }, "You must be at least 18 years old to register"),
  gender: z.string().min(1, "Gender is required")})

export const updateProfileSchema = z.object({
  user_details: z.object({...updateProfileFormSchema.shape})
});

export const updateNotificationSettingsSchema = z.object({
  notification_type: z.enum(["email", "sms"]),
  field: z.enum([
    "appointment_reminders",
    "prescription_refill_reminders",
  ]),
  value: z.boolean()
});